import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import Treeselect from '@riophae/vue-treeselect';
import TripServices from '../../../services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker'
import CONSTANT from '../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import Util from '../../../../shared/util/util';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import XLSX from 'xlsx';
const moment = require('moment');

export default{
  name: 'serviceareatemplate',
  components: {
    Validator,
    Multiselect,
    Treeselect,
    TripServices,
    VueElementLoading,
    DatePicker,
    Pagination,
    Loader,
    CustomExpandableTable,
  },
  data: function() {
    return {
        isLoading:false,
        AWB:"",
        tableArr:[],
        companyNamelist: [],
        zonelist: [],
        shortcuts:false,
        daterange:"",
        Statuslist:[
            { id:'0', label:'Pending'},
            { id:'1', label:'Re-Uploaded'},
            { id:'2', label:'No Action Required'},
          ],
		badpodreasons:[
			{ id:'0', label:'POD sent to HO'},
            { id:'1', label:'POD is lost'},	
		],
          status:null,
          tableColumn: ['AWB','Origin Hub', 'Destination Hub','Delivery Date', '1st POD Upload Date', 'Pod Review Date','POD Remarks','POD Status','FM/LM','Action'],
          innerTableColumn: [],
          tableItems: [],
          currentPage: 1,
          totalPage: 0,
          totalCount:0,
          offset:0,
          pageLimit:CONSTANT.PER_PAGE_DATA,
          showReuploadpod:false,
          defaultHubID:"",
		  zonename:'',
		  zone:null,
		  selectedZone:{value:'',text:''},
		  deliverydate:'',
		  firstpoduploaddate:'',
		  podreviewdate:'',
		  podremarks:'',
		  remarktype:'',
		  reUploadPodModal: false,
		  badpodreason :'',
		  openReuploadImage : false,
		  badpodreason: null,
		  shortcuts:false,
		  podUploadDate: '',
		  UploadType:'',
		  Image : '',
		  isReuploadImage:'',
		  imageEvent : '',
		  fileList:'',
		  file: '',
		  selectPODoption:'',
		  on:'',
		  PreviousPodImages:false,
		  isImageLoading:false,
		  caption:"Previous POD Image",
		  podimagearray:[],
		  image:"",
		  disablereason:true,
		  disableuplaodpod:true,

    }
  },
  mounted(){
	var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail
	this.userRoleFlag = userdetail.rolename[0] == "Admin" ? 1 : 2;
    this.defaultHubID = userdetail.hubID[0];
    this.userName = userdetail.email;
	this.getHubDetails()
	this.getPODDetails()
  },
  methods: {
	resetFilter(){
		this.zonename = ''
		this.zone = null
		this.AWB = ""
		this.podUploadDate = ""
		this.status =null
		this.getPODDetails();
	},
	async getHubDetails(){
		try{
		  this.isLoading = true
		  let hubId = []
		  let zoneDataList = []
		  let tempArr = [];
		  hubId.push(this.defaultHubID)
		  let input = {
			HubID:hubId
		  }
		  let result
		  if(this.userRoleFlag == 2){
			result = await TripServices.GetZoneForHub(input)
			for (var i = 0; i < result.data.data.length; i++) {
				tempArr.push({
				  'id': result.data.data[i].HubZoneId,
				  'label': result.data.data[i].HubZoneName
				})
			}
			this.zonelist = tempArr	
		  }else{
			result = await TripServices.getZoneList()
			if(result.data.code == 200) {
			  zoneDataList = result.data.states.data;
			  zoneDataList.forEach(element => {
				  if (element.hubzonename) {
					tempArr.push({
					  'id': element.hubzoneid,
					  'label': element.hubzonename,
					})
				  }
			  });
			  this.zonelist = tempArr;
		  }
		  
		  }
		  this.isLoading = false
		}catch(err){
		  this.isLoading = false
		  console.log(err)
		}
	  },
	  selectStatus(data){
		this.selectedStatus = data
	  },
	  selectZone(data){
        this.selectedZone = data;
        this.zonename = data.label;
      },
	  searchPODDetails(){
		this.currentPage = 1;
		this.offset = 0;
		this.getPODDetails();
	  },
	  async getPODDetails(){
		try {
			this.isLoading = true;
			this.tableItems = []
			let inputPayload = {
			  "offset": this.offset,
			  "limit": this.pageLimit,
			}
			if(this.AWB){
			  inputPayload.awb = this.AWB.trim();
			}
			if(this.status){
				inputPayload.status = this.selectedStatus.label
			}
			if(this.zonename){
				inputPayload.zone = this.zonename;
			}
			if(this.podUploadDate[0]){
				inputPayload.poduploaddate = this.podUploadDate;
			}else{
				this.poduploaddate = []
			}
			if(this.userRoleFlag == 2){
				inputPayload.hubid = this.defaultHubID
			}
			let result = await TripServices.getFLMPodDetails(inputPayload)
			if(result.data.data.code == 100){
				this.tableArr = result.data.data.data.rows;
				this.totalCount = result.data.data.data.count
				this.tableItems = result.data.data.data.rows.map((el)=>{
			       return {
					"id":el.id,
					'AWB':el.shippingid,
					'Origin Hub': el.originhub ? el.originhub :'NA',
					'Destination Hub': el.destinationhub ? el.destinationhub :'NA' ,
					'Delivery Date': (el.deliverydate!="NA") ? moment.utc(el.deliverydate).format("DD-MM-YYYY HH:mm:ss") : "NA",
					'1st POD Upload Date':(el.firstpoduploaddate!="NA") ? moment.utc(el.firstpoduploaddate).format("DD-MM-YYYY HH:mm:ss") : "NA",
					'Pod Review Date':(el.podreviewdate!="NA") ? moment.utc(el.podreviewdate).format("DD-MM-YYYY HH:mm:ss"): "NA",
					'POD Remarks':el.podremarks.toString(),
					'FM/LM': [... new Set(el.remarktype)].toString(),
					'POD Status': el.status ? el.status : 'NA' ,
				   }
	            })
				
			  }else{
				this.totalCount = 0
				this.tableItems = [];
			  }
			  if (this.totalCount < this.pageLimit) {
				this.totalPage = 1
			  } else {
				this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
			  }
			  this.isLoading = false;

		} catch (error) {
			console.log(error);
			this.isLoading = false;	
		}
	  },
	  onPageChange(page) {
		this.currentPage = page;
		this.offset = (page - 1) * this.pageLimit
		this.getPODDetails();
	  },
	  async getCustomTableEvent(id){
	   if (id.actionType == "isviewimage") {
		this.podimagearray = [];
		this.PreviousPodImages = true;
		this.isImageLoading = true;
		let awbId = id.id
		let input = {
		  "id":awbId
		};
		let result = await TripServices.getFLMPodDetails(input);

		if (result.data.data.code == 100) {
		  let podImages = result.data.data.data.rows[0]
		  if(podImages.imagefilepath && podImages.imagefilepath.length){
			podImages.imagefilepath.forEach((obj) => {
				this.podimagearray.push(obj);
			  });
		  }else{
			podImages.podimage.forEach((obj) => {
				this.podimagearray.push(obj);
			  });
		  }
			} else {
				this.podimagearray = [];
			}
			this.isImageLoading = false;
		}
		if (id.actionType == "isreuploadimage") {
			this.isLoading = true;
			let awbId = id.id
			let input = {
				"id": awbId
			};
			let result = await TripServices.getFLMPodDetails(input);
			this.AWB = result.data.data.data.rows[0].shippingid
			this.reUploadPodModal = true;
			this.isLoading = false;
		}

	  },
	  openImage(image) {
		this.image = image
		this.$nextTick(() => {
		  let modal = document.getElementById('myModalImg' + image);
		  var img = document.getElementById('imgid' + image);
		  var modalImg = document.getElementById("img" + image);
		  var captionText = document.getElementById("captionImg" + this.caption);
		  modal.style.display = "block";
		  modalImg.src = image;
		  captionText.innerHTML = this.caption;
		  this.PreviousPodImages =false;
		})
	  },
	  closemodal(id) {
		let modal = document.getElementById(id);
		modal.style.display = "none";
		this.PreviousPodImages =true;
	  },
	  closePreviousPodImages(){
        this.podimagearray = []
        this.PreviousPodImages = false;
      },
	  fileview(index){
		var link = document.createElement('a');
		link.href = index;
		link.setAttribute('target','_blank');
		window.open(index, '_blank');
		link.remove();
		return true;
	  },
	  resetReupload(){
		this.UploadType = null
		this.Image = null
		this.$refs.file.value = null
		//this.badpodreasons = null
		this.badpodreason = null
		this.selectPodOption = null
		this.disableuplaodpod = true
		this.disablereason = true
		this.AWB = ''
		this.selectPodOption = ''
	},
	uploadpod(event) {
		this.selectPodOption = event.target.value
		if (this.selectPodOption == 1) {
			this.disableuplaodpod = false
			this.disablereason = true
			this.badpodreason = null
		} else if(this.selectPodOption == 0){
			this.disableuplaodpod = true
			this.disablereason = false
			this.$refs.file.value = null
		}
		console.log("Selected Opyion--", this.selectPodOption)
	},
	closeReuploadPOD() {
		this.reUploadPodModal = false;
		this.resetReupload()
	},
	selectPODReason(reason) {
		//this.badpodreason = reason.label
		this.newvar = reason
	},
	async FileUpload(event) {
		this.imageEvent = event
		this.imagearray = []
	},
	async handleFileUpload() {
		this.isLoading = true
		let formData = new FormData();
		formData.append("awb", this.AWB)
		formData.append("userName",this.userName)
		if (this.selectPodOption == 0 && this.selectPodOption!=="") {
			if(this.badpodreason){
				formData.append("checked", false)
				formData.append("notavailablereason", this.newvar.label)
				let result = await TripServices.uploadPodData(formData)
				if (result.data.data.code == 100) {
					this.$alertify.success("Reason successfully Added!");
				} else {
					this.$alertify.error("Reason Not Added. Please try again");
				}
				this.reUploadPodModal = false;
				this.resetReupload()
			}else{
				this.$alertify.error("Please select a reason");
			}
		} else if (this.selectPodOption) {
			if(this.imageEvent){
				formData.append("checked", true)
				let uploadEvent = this.imageEvent
				if (uploadEvent) {
					let uploadFile = uploadEvent.target.files;
					this.imagearray = []
					/*Add the form data we need to submit*/
					for (let key in uploadFile) {
						if (key >= 0) {
							if (uploadFile[key].type != "image/jpeg" &&
								uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png") {
								this.$alertify.error("Please upload only valid file format");
								this.isLoading = false
								return false
							}
						}
						if (key == 'length' && uploadFile[key] > 3) {
							this.$alertify.error("Please upload maximum 3 file");
							this.isLoading = false
							return false
						}
						if (uploadFile[key].size > (1024 * 1024 * 3)) {
							this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
							this.isLoading = false
							return false
						} else {
							formData.append("file", uploadFile[key]);
						}
					}
					//api --call
					let result = await TripServices.uploadPodData(formData)
					if (result.data.data.code == 200) {
						this.$alertify.success("Images uploaded successfully !");
					} else {
						this.$alertify.error("Images could not be uploaded.");
						this.isLoading = false
					}
					this.isLoading = false
				} else {
					this.$alertify.error("Please Upload File again");
					this.isLoading = false
				}
				this.reUploadPodModal = false;
				this.resetReupload()
			}else{
				this.$alertify.error("Please select a file");
			}
		} else {
			this.$alertify.error("Please select atleast one option or Close it");
		}
		this.isLoading = false
		this.getPODDetails();
	},

	  async DownloadRequestedData(){
		try {
		  this.isLoading = true;
		  let inputPayload = {
		  }
		  if(this.AWB){
		    inputPayload.awb = this.AWB	
		  }
		  if(this.status){
		    inputPayload.status = this.selectedStatus.label
		  }
		  if(this.zonename){
		    inputPayload.zone = this.zonename
		  }
		  if(this.podUploadDate[0]){
			inputPayload.poduploaddate = this.podUploadDate;
		  }else{
			this.poduploaddate = []
		  }
		  if(this.userRoleFlag == 2){
			inputPayload.hubid = this.defaultHubID
		 }
		  let result = await TripServices.getallFLMPodDetails(inputPayload)
		  let tempdata  = result.data.data.data.rows.map((el)=>{
			return {
				'AWB':el.shippingid,
				'Origin Hub': el.originhub ? el.originhub :'NA',
				'Destination Hub': el.destinationhub ? el.destinationhub :'NA' ,
				'Delivery Date': (el.deliverydate!="NA") ? moment.utc(el.deliverydate).format("DD-MM-YYYY HH:mm:ss") : "NA",
				'1st POD Upload Date':(el.firstpoduploaddate!="NA") ? moment.utc(el.firstpoduploaddate).format("DD-MM-YYYY HH:mm:ss") : "NA",
				'Pod Review Date':(el.podreviewdate!="NA") ? moment.utc(el.podreviewdate).format("DD-MM-YYYY HH:mm:ss"): "NA",
				'POD Remarks': el.podremarks.toString(),
				'POD Status': el.status ? el.status : 'NA',
				'FM/LM':[... new Set(el.remarktype)].toString(),
			}
		  })
			let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
			const data = XLSX.utils.json_to_sheet(tempdata);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, data, 'data')
			XLSX.writeFile(wb,dt+'_poddata.xlsx');

		  this.isLoading = false;
		} catch(err){
		  console.log(err);
		  this.isLoading = false;
		}
	  },
  },	
}


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/POD/reuploadpod/pod.component.js